import { cx } from "class-variance-authority";

import { Svg } from "../../../utils/svgIcon";

import caretSvg from "./sidebar-caret.svg";
import * as theme from "./SidebarCaret.css";

export interface SidebarCaretProps {
    expanded: boolean;
    className?: string;
}

// Collapsed is the asset turned over — the opposite way round to a chevron-down.
export function SidebarCaret({ expanded, className }: SidebarCaretProps) {
    return (
        <Svg
            src={caretSvg}
            className={cx(theme.root, !expanded && theme.collapsed, className)}
        />
    );
}
